<template lang="pug">
v-container.tabs-management.pa-8(fluid)
    v-row
      v-col
        h2.primary--text {{ $t('Portal.extraFields') }}
      v-col
        g-select(
          :value="selectedGroups",
          @input="cleanSelected"
          :items="displayFields",
          multiple,
          item-text="name",
          item-value="id",
          :label="$t('Portal.extraFieldsGroup')",
          return-object,
        )
          template(v-slot:selection="{ index }")
            template(v-if="index === 0")
              h9.primaryHover--text {{ $t('Portal.extraFieldsGroup') }}
    v-row
      v-col
        template(v-for="(group, indexGroup) in selectedGroups")
          h5 {{ $displayName(group.name) }}
          div(
            v-for="(field, index) in group.fields",
            :key="field.extraFieldId",
          )
            v-checkbox(
              :label="`${field.name}`",
              :input-value="hasValue(field.extraFieldId)",
              @change="input($event, field, group)",
            )
            template(v-if="indexGroup != (selectedGroups.length - 1)")
              v-divider
            template(v-else)
              v-divider(v-if="index != (group.fields.length - 1)")
</template>

<style lang="scss" scoped>
.tabs-management {
  .g-select {
    ::v-deep .v-label {
      font-size: 12px;
    }
  }
}
</style>

<script>
import ExtraFieldEditor from "./ExtraFieldEditor";

export default {
  components: {
    ExtraFieldEditor,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    }
  },
  data: () => ({
    selectedGroups: [],
  }),
  methods: {
    hasValue(extraFieldId) {
      return !!this.value.find(({ fields }) => {
        return _.some(fields, f => f.extraFieldId === extraFieldId);
      });
    },
    input($event, pField, pGroup) {
      let copyValue = _.cloneDeep(this.value);
      let copyGroup = _.cloneDeep(pGroup);
      let field = _.cloneDeep(pField);

      // Referenced group to be mutated
      let foundGroup = copyValue.find(g => g.name === copyGroup.name);

      // Event dictates checkbox action: add or delete extrafield
      if ($event) {
        // If add extrafield to found group, just push it to its fields
        if (foundGroup) {
          foundGroup.fields.push(field);
        // Else push the group with this field as its only one
        } else {
          copyGroup.fields = [field];
          copyValue.push(copyGroup);
        }
      } else {
        // The group should exist on the value if it's being eliminated
        if (foundGroup) {
          // Filter out from the fields the selected field
          foundGroup.fields = foundGroup.fields.filter(f => f.extraFieldId !== field.extraFieldId);
          // If there are no fields on the group, filter it out from the value
          if (foundGroup.fields.length == 0) {
            copyValue = copyValue.filter(g => g.name !== copyGroup.name);
          }
        }
      }

      this.$emit('input', copyValue);
    },
    cleanSelected(val) {
      this.selectedGroups = val;
      let copyValue = _.cloneDeep(this.value);

      copyValue = copyValue.filter(g => this.selectedGroups.find(sg => sg.name === g.name));

      if (this.value.length != copyValue.length)
        this.$emit('input', copyValue);
    },
  },
  computed: {
    displayFields() {
      return this.fields;
    },
  },
  created() {
    if (this.value.length > 0) {
      this.selectedGroups = this.fields.filter(({ name }) => {
        return this.value.find(valueField => valueField.name === name);
      })
    }
  }
}
</script>
